var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { BigNumber, Contract, utils } from 'ethers';
import { getPluginInstanceFrom } from '../../../../Fct';
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctTradingGraphProps, isVariable, } from '../../../../Fct/generics';
import { FctValue } from '../../../../Fct/generics';
import { GAS_LIMIT_OVERHEAD, MIN_GAS_LIMIT, paramKeyToName } from '../../../../Fct/helpers';
import { kiroboMulticallContractsMap, kiroboMulticallSimulateContracts, } from '../../../../Fct/plugins/KIROBO_MULTICALL_CSV/constants';
import { set } from 'lodash';
import multicallAbi from './Multicall.abi.json';
export var MULTICALL_CONTRACT_ADDRESS = {
    '1': '0x0ae3Ef19F87b5931aC8fBc3E01bbEca8DB185849',
    '10': '0x92B83232F2579D77BE181Dc2b167f9a542F2e0DE',
    '42161': '0xD8d95c30874DfBD9981272c5d0F0729BA523D475',
    '8453': '0xC7D810CEc1465C85345eD7C2B103E7E6109eBE47',
    '11155111': '0x64754348Aa0fb27Cce9c40214e240755bBBcb265',
};
var Multicall = /** @class */ (function () {
    function Multicall(_plugin, _protocol, _type, _method, _name, _config, _chainId, _vaultAddress, _walletAddress, _addPluginOnInit, _withPluginOutputs, _estimateGasFromPlugins, _beforeSimulate, _flowType) {
        var _this = this;
        this._plugin = _plugin;
        this._protocol = _protocol;
        this._type = _type;
        this._method = _method;
        this._name = _name;
        this._config = _config;
        this._chainId = _chainId;
        this._vaultAddress = _vaultAddress;
        this._walletAddress = _walletAddress;
        this._addPluginOnInit = _addPluginOnInit;
        this._withPluginOutputs = _withPluginOutputs;
        this._estimateGasFromPlugins = _estimateGasFromPlugins;
        this._beforeSimulate = _beforeSimulate;
        this._flowType = _flowType;
        this._plugins = [];
        this.getOutputValues = function (_a) {
            var provider = _a.provider, walletSigner = _a.walletSigner, execute = _a.execute, withAutoApprovals = _a.withAutoApprovals, service = _a.service;
            return __awaiter(_this, void 0, void 0, function () {
                var currentGasLimit, multicallInterface, output, params, getParamValue_1, response, data_1, outputs, i, mOutputs, call, res;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0:
                            this.currentGasLimit = undefined;
                            currentGasLimit = BigNumber.from('0');
                            multicallInterface = this.getInterface();
                            output = multicallInterface.instance.output;
                            if (!(this._flowType === 'OFFCHAIN_ONLY')) return [3 /*break*/, 2];
                            params = multicallInterface.instance.input.paramsList;
                            getParamValue_1 = function (param) {
                                if (!param)
                                    return;
                                if (param.isVariable)
                                    return param.estimatedValue;
                                return param.value;
                            };
                            return [4 /*yield*/, service.getData({
                                    endpoint: (_b = params.find(function (_a) {
                                        var key = _a.key;
                                        return key === 'endpoint';
                                    })) === null || _b === void 0 ? void 0 : _b.param.value,
                                    query: this._plugins.map(function (plugin) {
                                        var _a, _b;
                                        var key = getParamValue_1((_a = plugin.input.paramsList.find(function (param) { return param.key === 'paramKey'; })) === null || _a === void 0 ? void 0 : _a.param);
                                        var value = getParamValue_1((_b = plugin.input.paramsList.find(function (param) { return param.key === 'paramValue'; })) === null || _b === void 0 ? void 0 : _b.param);
                                        return { key: key, value: value };
                                    }),
                                })];
                        case 1:
                            response = _c.sent();
                            if (!response.data)
                                return [2 /*return*/, { params: {}, error: 'request off-chain data error' }];
                            data_1 = response.data;
                            this._plugins.map(function (plugin, i) {
                                var _a;
                                if (!data_1[i]) {
                                    return;
                                }
                                var output = (_a = plugin.output.paramsList.find(function (param) { return param.key === 'responseValue'; })) === null || _a === void 0 ? void 0 : _a.param;
                                if (!output)
                                    return;
                                output.label = data_1[i].name;
                                output.value = data_1[i].value;
                            });
                            return [2 /*return*/, {}];
                        case 2:
                            outputs = {};
                            i = 0;
                            mOutputs = this.output.paramsList;
                            if (!this._beforeSimulate) return [3 /*break*/, 5];
                            if (walletSigner && withAutoApprovals && this.getRequiredApprovals(true).length) {
                                provider.signer = walletSigner;
                            }
                            return [4 /*yield*/, this.create(true, provider.provider)];
                        case 3:
                            call = _c.sent();
                            return [4 /*yield*/, this._beforeSimulate({ chainId: this.chainId, provider: provider, params: call === null || call === void 0 ? void 0 : call.params })];
                        case 4:
                            _c.sent();
                            _c.label = 5;
                        case 5: return [4 /*yield*/, this._getOutputValues({ provider: provider, execute: execute })];
                        case 6:
                            res = _c.sent();
                            res.trx.forEach(function (value, i) {
                                outputs[mOutputs[i].key] = value.toString();
                            });
                            if (res.gasLimit)
                                currentGasLimit = currentGasLimit.add(res.gasLimit).mul(115).div(100).add(GAS_LIMIT_OVERHEAD);
                            this.currentGasLimit = currentGasLimit.add(MIN_GAS_LIMIT).add(GAS_LIMIT_OVERHEAD).toString();
                            return [2 /*return*/, outputs];
                    }
                });
            });
        };
        this.add = function (pluginNodeJSON) {
            if (!_this.chainId) {
                console.error("chainId error: set chainId");
                return;
            }
            var pluginConstructors = _this._plugin;
            if ('length' in pluginConstructors && pluginConstructors.length > 1) {
                var multiPluginConstructor = pluginConstructors;
                multiPluginConstructor.forEach(function (constructor) {
                    var pluginJSON = new constructor({
                        chainId: _this.chainId,
                        walletAddress: _this._walletAddress,
                        vaultAddress: _this._vaultAddress,
                    }).toJSON();
                    var plugin = _this.jsonToPlugin(pluginJSON, _this.chainId);
                    if (!plugin) {
                        console.error('plugin error');
                        return;
                    }
                    _this._plugins.push(plugin);
                });
            }
            else {
                var pluginConstructor = pluginConstructors;
                var pluginJSON = pluginNodeJSON ||
                    new pluginConstructor({
                        chainId: _this.chainId,
                        walletAddress: _this._walletAddress,
                        vaultAddress: _this._vaultAddress,
                    }).toJSON();
                var plugin = _this.jsonToPlugin(pluginJSON, _this.chainId);
                if (!plugin) {
                    console.error('plugin error');
                    return;
                }
                _this._plugins.push(plugin);
            }
            _this.updateSubscriptions();
            return _this;
        };
        this.remove = function () {
            if (_this._plugins.length > 1) {
                _this._plugins.pop();
                _this.updateSubscriptions();
            }
            return _this;
        };
        this.removeAll = function () {
            _this._plugins = [];
            // this.updateSubscriptions()
            return _this;
        };
        this.toJSON = function () {
            var _a;
            var pluginsInterface = _this.getInterface();
            var json = JSON.parse(pluginsInterface.instance.toJSON());
            json.pluginsAmount = Number((_a = pluginsInterface.instance.input.params.amountOfCalls) === null || _a === void 0 ? void 0 : _a.value) || _this.pluginsLength;
            // this.plugins.forEach((plugin) => {
            //   data.push(plugin.toJSON())
            // })
            return JSON.stringify(json);
        };
        this.fromJSON = function (multicallJSON) {
            try {
                var multicallPlugins = JSON.parse(multicallJSON);
                if (multicallPlugins.pluginsAmount) {
                    _this.removeAll();
                }
                var step = _this._plugin.length;
                for (var i = 0; i < multicallPlugins.pluginsAmount; i += 1) {
                    _this.add();
                }
                var pluginsInterface = _this.getInterface();
                pluginsInterface.instance.fromJSON(multicallJSON);
                if (pluginsInterface.instance.input.params.amountOfCalls)
                    pluginsInterface.instance.input.params.amountOfCalls.value = String(multicallPlugins.pluginsAmount);
            }
            catch (e) {
                console.error(e);
            }
            return true;
        };
        this.jsonToPlugin = function (plugin, chainId) {
            var _a;
            return (_a = getPluginInstanceFrom({
                json: plugin,
                chainId: chainId,
                vaultAddress: _this._vaultAddress,
                walletAddress: _this._walletAddress,
            })) === null || _a === void 0 ? void 0 : _a.instance;
        };
        this.subscribe = function (_a) {
            var callback = _a.callback, id = _a.id;
            _this.observers.set(id, callback);
        };
        this.unsubscribe = function (_a) {
            var id = _a.id;
            _this.observers.delete(id);
        };
        this.pluginParamsToMulticallParamsTuples = function () {
            var _a;
            var uniqueParams = (_a = _this.plugins[0]) === null || _a === void 0 ? void 0 : _a.input.paramsList.map(function (param) {
                var paramConfig = _this.config.params.find(function (p) { return p.key === param.key; });
                if (!(paramConfig === null || paramConfig === void 0 ? void 0 : paramConfig.isUnique))
                    return;
                var paramKey = paramConfig ? paramConfig.multicallKey : param.key;
                var newKey = paramKey;
                param.key = newKey;
                param.param.label = paramKey;
                param.param.isPreview = paramConfig.isPreview;
                return param;
            }).filter(Boolean);
            var inputs = _this.plugins.map(function (plugin, index) {
                return plugin.input.paramsList
                    .map(function (param) {
                    var _a;
                    var paramConfig = _this.config.params.find(function (p) { return p.key === param.key; });
                    var paramKey = paramConfig ? paramConfig.multicallKey : param.key;
                    var newKey = "".concat(paramKey, "_").concat(index);
                    if (paramConfig === null || paramConfig === void 0 ? void 0 : paramConfig.isUnique) {
                        var uniqueParam = (_a = uniqueParams === null || uniqueParams === void 0 ? void 0 : uniqueParams.find(function (param) { return (param === null || param === void 0 ? void 0 : param.key) === paramKey; })) === null || _a === void 0 ? void 0 : _a.param;
                        if (uniqueParam && index > 0) {
                            uniqueParam.subscribe({
                                callback: function (event) {
                                    if (param.param instanceof FctTradingGraphProps)
                                        return;
                                    param.param.set({ value: event.value });
                                },
                                id: "multicall.".concat(_this.method, ".").concat(newKey),
                            });
                        }
                        return;
                    }
                    param.key = newKey;
                    param.param.label = paramKey;
                    param.param.isMultiParam = !(paramConfig === null || paramConfig === void 0 ? void 0 : paramConfig.isUnique);
                    return param;
                })
                    .filter(Boolean);
            });
            var outputs = _this._withPluginOutputs
                ? _this.plugins.map(function (plugin, index) {
                    return plugin.output.paramsList.map(function (param, pluginOutputIndex) {
                        var paramKey = param.key;
                        var newKey = "".concat(paramKey, "_").concat(index);
                        param.key = newKey;
                        if (_this.method === 'multiCall') {
                            if (_this.type === 'LIBRARY:VIEWONLY') {
                                param.param.innerIndex = 2 + _this.plugins.length + (index * 2 + 1);
                            }
                            else {
                                var isLastOutput = index + 1 === _this.plugins.length && pluginOutputIndex + 1 === plugin.output.paramsList.length;
                                if (isLastOutput) {
                                    param.param.hidden = false;
                                    param.param.innerIndex = -1;
                                }
                                else {
                                    param.param.hidden = true;
                                }
                            }
                        }
                        else {
                            param.param.innerIndex = index + 2;
                        }
                        param.param.label = paramKey;
                        param.param.isMultiParam = true;
                        return param;
                    });
                })
                : [];
            return { inputs: inputs, outputs: outputs, uniqueParams: uniqueParams, onchainParams: uniqueParams.filter(function (_a) {
                    var key = _a.key;
                    return key !== 'isOffChainOnly';
                }) };
        };
        this.create = function (isEstimation, testProvider) { return __awaiter(_this, void 0, void 0, function () {
            var errors, _a, inputs, onchainParams, tupleParams, getParamValue, _b, callParams, callType, call;
            var _this = this;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        errors = this.plugins
                            .map(function (plugin) {
                            return plugin.input.errors;
                        })
                            .filter(Boolean);
                        if (errors.length) {
                            console.error(errors);
                            return [2 /*return*/, undefined];
                        }
                        _a = this.pluginParamsToMulticallParamsTuples(), inputs = _a.inputs, onchainParams = _a.onchainParams;
                        tupleParams = {
                            name: this.config.tupleName || this.name,
                            type: 'tuple[]',
                            value: [],
                        };
                        getParamValue = function (param) {
                            if (!isEstimation)
                                return param.value;
                            if (isVariable(param.value))
                                return param.estimatedValue;
                            return param.value;
                        };
                        if (!(this.method === 'multiCall')) return [3 /*break*/, 2];
                        tupleParams.customType = true;
                        return [4 /*yield*/, Promise.all(this.plugins.map(function (plugin) { return __awaiter(_this, void 0, void 0, function () {
                                var trxParam, callData;
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            trxParam = [];
                                            return [4 /*yield*/, plugin.getCalldata(isEstimation, testProvider)];
                                        case 1:
                                            callData = _b.sent();
                                            if (!callData)
                                                return [2 /*return*/];
                                            Object.keys(callData).map(function (key) {
                                                var callKey = key;
                                                var callDataParam = callData[callKey];
                                                trxParam.push({
                                                    name: key,
                                                    type: callDataParam.type,
                                                    value: callDataParam.value,
                                                });
                                            });
                                            (_a = tupleParams.value) === null || _a === void 0 ? void 0 : _a.push(trxParam);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 1:
                        _c.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        _b = tupleParams;
                        return [4 /*yield*/, Promise.all(inputs.map(function (inputParams) { return __awaiter(_this, void 0, void 0, function () {
                                var param, trxParam;
                                return __generator(this, function (_a) {
                                    if (inputParams.length === 1) {
                                        param = inputParams[0].param;
                                        tupleParams.type = "".concat(param.fctType, "[]");
                                        return [2 /*return*/, getParamValue(param)];
                                    }
                                    trxParam = [];
                                    tupleParams.customType = true;
                                    inputParams.forEach(function (_a) {
                                        var param = _a.param, key = _a.key;
                                        trxParam.push({
                                            name: param.label || paramKeyToName({ key: key }),
                                            type: param.fctType,
                                            value: getParamValue(param),
                                        });
                                    });
                                    return [2 /*return*/, trxParam];
                                });
                            }); }))];
                    case 3:
                        _b.value = _c.sent();
                        _c.label = 4;
                    case 4:
                        callParams = [];
                        if (onchainParams && onchainParams.length) {
                            onchainParams.forEach(function (_a) {
                                var param = _a.param, key = _a.key;
                                callParams.push({
                                    name: param.label || paramKeyToName({ key: key }),
                                    type: param.fctType,
                                    value: getParamValue(param),
                                });
                            });
                        }
                        if (tupleParams && tupleParams.value) {
                            callParams.push(tupleParams);
                        }
                        callType = this.type === 'LIBRARY:VIEWONLY' ? 'LIBRARY_VIEW_ONLY' : 'LIBRARY';
                        call = {
                            value: '0',
                            to: MULTICALL_CONTRACT_ADDRESS[this.chainId],
                            method: this.method,
                            params: callParams,
                            toENS: this.toENS,
                            options: {
                                gasLimit: this.gasLimit,
                                falseMeansFail: false,
                                callType: callType,
                            },
                        };
                        return [2 /*return*/, call];
                }
            });
        }); };
        this.getOutputParamsTypes = function () {
            if (_this.method === 'multiCall') {
                return [_this.plugins.map(function (pl) { return pl.output.paramsList.map(function (_a) {
                        var param = _a.param;
                        return param.fctType;
                    }); })];
            }
            return ["".concat(_this.output.paramsList[0].param.fctType, "[]")];
        };
        this._getOutputValues = function (_a) {
            var provider = _a.provider, execute = _a.execute;
            return __awaiter(_this, void 0, void 0, function () {
                var call, simulateContractAddress, contract, singerAddress, trx, res, methodParams, e_1, error, outputTypes, abiCoder, outputParams;
                var _b;
                return __generator(this, function (_c) {
                    switch (_c.label) {
                        case 0: return [4 /*yield*/, this.create(true, provider.provider)];
                        case 1:
                            call = _c.sent();
                            if (!call) {
                                throw new Error('wrong multicall data');
                            }
                            simulateContractAddress = this.method === 'erc20Approvals'
                                ? kiroboMulticallContractsMap[this.chainId]
                                : kiroboMulticallSimulateContracts[this.chainId];
                            contract = new Contract(simulateContractAddress, multicallAbi, provider.signer);
                            return [4 /*yield*/, provider.signer.getAddress()];
                        case 2:
                            singerAddress = _c.sent();
                            _c.label = 3;
                        case 3:
                            _c.trys.push([3, 7, , 8]);
                            methodParams = call === null || call === void 0 ? void 0 : call.params.map(function (param) {
                                if (!param.value)
                                    return param.value;
                                if (typeof param.value === 'string')
                                    return param.value;
                                if (typeof param.value === 'object' && 'length' in param.value) {
                                    if (param.type !== 'tuple[]')
                                        return param.value;
                                    return param.value.map(function (paramValue) {
                                        var p = [];
                                        if (paramValue && typeof paramValue === 'object' && 'length' in paramValue)
                                            paramValue.forEach(function (_p, i) {
                                                p[i] = _p.value;
                                                //p[_p.name] = _p.value
                                            });
                                        return p;
                                    });
                                }
                                return undefined;
                            });
                            return [4 /*yield*/, (_b = contract.callStatic)[this.method].apply(_b, __spreadArray(__spreadArray([], __read(methodParams), false), [{
                                        from: singerAddress,
                                        value: '0',
                                    }], false))];
                        case 4:
                            trx = (_c.sent());
                            if (!execute) return [3 /*break*/, 6];
                            return [4 /*yield*/, contract[this.method].apply(contract, __spreadArray(__spreadArray([], __read(methodParams), false), [{
                                        from: singerAddress,
                                        value: '0',
                                    }], false))];
                        case 5:
                            res = _c.sent();
                            _c.label = 6;
                        case 6:
                            console.log({ res: res });
                            if (this.method !== 'multiCall')
                                return [2 /*return*/, { trx: trx, gasLimit: res === null || res === void 0 ? void 0 : res.gasLimit }
                                    //return { trx }
                                ];
                            return [3 /*break*/, 8];
                        case 7:
                            e_1 = _c.sent();
                            error = new Error(e_1);
                            throw error;
                        case 8:
                            outputTypes = this.plugins.map(function (pl) { return pl.output.paramsList.map(function (_a) {
                                var param = _a.param;
                                return param.fctType;
                            }); });
                            abiCoder = new utils.AbiCoder();
                            outputParams = trx.map(function (bytes, i) { return abiCoder.decode(outputTypes[i], bytes); });
                            return [2 /*return*/, { trx: outputParams, gasLimit: res === null || res === void 0 ? void 0 : res.gasLimit }];
                    }
                });
            });
        };
        this.getRequiredApprovals = function (isEstimation) {
            var requiredApprovals = [];
            _this.plugins.forEach(function (plugin) {
                var pluginApprovals = plugin.getRequiredApprovals(isEstimation);
                requiredApprovals = requiredApprovals.concat(pluginApprovals);
            });
            return requiredApprovals;
        };
        this.observers = new Map();
        this.updateSubscriptions = function () {
            var e_2, _a;
            var multicallInterface = _this.getInterface();
            try {
                for (var _b = __values(_this.observers), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var observer = _c.value;
                    observer[1](multicallInterface, undefined, _this.chainId, _this.currentGasLimit);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_2) throw e_2.error; }
            }
        };
        if (this.pluginsLength)
            return;
        if (this._addPluginOnInit === false)
            return;
        this.add();
    }
    Object.defineProperty(Multicall.prototype, "chainId", {
        get: function () {
            return this._chainId;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "type", {
        get: function () {
            return this._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "protocol", {
        get: function () {
            return this._protocol;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "method", {
        get: function () {
            return this._method;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "name", {
        get: function () {
            return this._name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "toENS", {
        get: function () {
            return '@lib:multicall';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "config", {
        get: function () {
            return this._config;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "contractInterface", {
        get: function () {
            return this.methodInterface;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "methodInterface", {
        get: function () {
            var _a = this.pluginParamsToMulticallParamsTuples(), inputs = _a.inputs, onchainParams = _a.onchainParams;
            var pluginInputs = inputs[0];
            var paramsToTypes = function (inputs) {
                var types = '';
                inputs.forEach(function (_a) {
                    var param = _a.param;
                    types += "".concat(param._fctType, ",");
                });
                types = types.replace(/,$/, '');
                return types;
            };
            var listInterface = pluginInputs.length > 1 ? "(".concat(paramsToTypes(pluginInputs), ")[]") : "".concat(paramsToTypes(pluginInputs), "[]");
            if (onchainParams && onchainParams.length)
                return "".concat(this.method, "(").concat(paramsToTypes(onchainParams), ",").concat(listInterface, ")");
            return "".concat(this.method, "(").concat(listInterface, ")");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "methodInterfaceHash", {
        get: function () {
            return utils.id(this.methodInterface);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "contractInterfaceReturns", {
        get: function () {
            var outputs = this.pluginParamsToMulticallParamsTuples().outputs;
            var pluginOutputs = outputs.length ? outputs[0] : [];
            var types = '';
            pluginOutputs.forEach(function (_a) {
                var param = _a.param;
                types += "".concat(param._fctType, ",");
            });
            types = types.replace(/,$/, '');
            return "returns (".concat(types, "[])");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "plugins", {
        get: function () {
            return this._plugins;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "pluginsLength", {
        get: function () {
            return this._plugins.length / this._plugin.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "gasLimit", {
        get: function () {
            var e_3, _a;
            if (this.currentGasLimit)
                return this.currentGasLimit;
            if (this._estimateGasFromPlugins)
                return this._estimateGasFromPlugins(this.plugins, this.chainId);
            var MIN_GAS_LIMIT = '42000';
            var gasLimit = MIN_GAS_LIMIT;
            try {
                for (var _b = __values(this.plugins), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var plugin = _c.value;
                    var pluginGasLimit = plugin.gasLimit && BigNumber.from(plugin.gasLimit).gte(MIN_GAS_LIMIT)
                        ? plugin.gasLimit
                        : BigNumber.from(MIN_GAS_LIMIT).mul(2).toString();
                    gasLimit = BigNumber.from(gasLimit).add(pluginGasLimit).sub(MIN_GAS_LIMIT).toString();
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_3) throw e_3.error; }
            }
            return gasLimit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "input", {
        get: function () {
            return this.getInterface().instance.input;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Multicall.prototype, "output", {
        get: function () {
            return this.getInterface().instance.output;
        },
        enumerable: false,
        configurable: true
    });
    Multicall.prototype.getInterface = function (prev) {
        var newInputValues = {};
        var newOutputValues = {};
        var _a = this.pluginParamsToMulticallParamsTuples(), inputs = _a.inputs, outputs = _a.outputs, uniqueParams = _a.uniqueParams;
        var amountOfCallsParam = new FctValue({ required: false, mode: 'INPUT' });
        amountOfCallsParam.value = String(this.pluginsLength) || '1';
        amountOfCallsParam.virtual = true;
        amountOfCallsParam.isPreview = true;
        set(newInputValues, 'amountOfCalls', amountOfCallsParam);
        uniqueParams.forEach(function (param) {
            if (!param)
                return;
            set(newInputValues, param.key, param.param);
        });
        inputs.forEach(function (pluginParams) {
            pluginParams.forEach(function (param) {
                set(newInputValues, param.key, param.param);
            });
        });
        outputs.forEach(function (pluginParams) {
            pluginParams.forEach(function (param) {
                set(newOutputValues, param.key, param.param);
            });
        });
        var Plugin = createPlugin({
            protocol: this.protocol,
            type: this.type,
            name: this.name,
            method: this.method,
            isMulticallPlugin: true,
            flowType: this._flowType,
            getParams: function () { return ({
                input: newInputValues,
                output: newOutputValues,
            }); },
        });
        var newPlugin = new Plugin({ chainId: this.chainId });
        newPlugin.input.setMethodParams = this.setMethodParams;
        newPlugin.output.setOutputParams = this.setOutputParams;
        if (prev === null || prev === void 0 ? void 0 : prev.instance) {
            newPlugin.observers = prev.instance.observers;
            newPlugin.input.observers = prev.instance.input.observers;
            newPlugin.output.observers = prev.instance.output.observers;
        }
        return {
            instance: newPlugin,
            details: { plugin: Plugin, name: this.name, description: this.name },
        };
    };
    Multicall.prototype.setMethodParams = function (params) {
        var _this = this;
        var methodParamsConfig = this.config.params.filter(function (_a) {
            var key = _a.key;
            return key !== 'isOffChainOnly';
        });
        params.some(function (param, i) {
            var paramConfig = methodParamsConfig[i];
            if (paramConfig.isUnique)
                return false;
            if (typeof param === 'object' && 'length' in param) {
                while (_this.pluginsLength < param.length) {
                    _this.add();
                }
                return true;
            }
            return false;
        });
        var pluginInterface = this.getInterface();
        //pluginInterface.instance.input
        params.forEach(function (param, i) {
            var _a;
            var paramConfig = methodParamsConfig[i];
            if (paramConfig.isUnique) {
                pluginInterface.instance.input.set((_a = {}, _a[paramConfig.multicallKey] = param, _a));
                return;
            }
            if (typeof param === 'object' && 'length' in param) {
                param.forEach(function (tupleParamValue, tupleIndex) {
                    var _a;
                    if (typeof tupleParamValue === 'string' || typeof tupleParamValue === 'boolean') {
                        pluginInterface.instance.input.set((_a = {}, _a["".concat(paramConfig.multicallKey, "_").concat(tupleIndex)] = tupleParamValue, _a));
                    }
                    if (typeof tupleParamValue === 'object' && 'length' in tupleParamValue) {
                        tupleParamValue.forEach(function (tuplePramNestedValue, nestedTupleIndex) {
                            var _a;
                            var nestedParamConfig = methodParamsConfig[i + nestedTupleIndex];
                            pluginInterface.instance.input.set((_a = {},
                                _a["".concat(nestedParamConfig.multicallKey, "_").concat(tupleIndex)] = tuplePramNestedValue,
                                _a));
                        });
                    }
                });
            }
            return;
        });
    };
    Multicall.prototype.setOutputParams = function (params) {
        if (typeof params !== 'object' || !('length' in params))
            return;
        var paramsValues = [];
        var getValues = function (params) {
            if (typeof params === 'string' || typeof params === 'boolean') {
                paramsValues.push(params);
            }
            if (params && typeof params === 'object' && 'length' in params) {
                var paramsArray = params;
                paramsArray.forEach(function (param) {
                    getValues(param);
                });
            }
            return;
        };
        getValues(params);
        while (this.pluginsLength < paramsValues.length) {
            this.add();
        }
        var pluginInterface = this.getInterface();
        pluginInterface.instance.output.paramsList.forEach(function (param, i) {
            var paramValue = paramsValues[i];
            if (typeof paramValue === 'string' || typeof paramValue === 'boolean') {
                param.param.set({ value: paramValue });
            }
            if (typeof paramValue === 'object' && 'length' in paramValue) {
                param.param.set({ value: paramValue[0] });
            }
        });
    };
    Object.defineProperty(Multicall.prototype, "currentGasLimit", {
        get: function () {
            return this._currentGasLimit;
        },
        set: function (gasLimit) {
            this._currentGasLimit = gasLimit;
            this.updateSubscriptions();
        },
        enumerable: false,
        configurable: true
    });
    return Multicall;
}());
export { Multicall };
